import { CameraView } from './types';

export const defaultCameraView: CameraView = {
  lookAt: { x: 0, y: 0 }
};
